import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ReactTooltip from "react-tooltip";
import Toast from "react-bootstrap/Toast";
import axios from "axios";
import { QuestionCircle } from "react-bootstrap-icons";
import { REQUIRED_FIELDS, DELEGATE } from "./constants";
import {
    emailValidation,
    userNameValidation,
    emailVerifyMatch,
    ssnValidation
} from "./validation";
import { analytics } from "./analytics";
import { Header, Footer, DisclaimerPolicyOwner } from "./components";
import TermsAndConditions from "./Terms&ConditionsFP";
import "react-datepicker/dist/react-datepicker.css";
import { getIPAddress } from "./utils/getIPAddress";

const DelegateEnroll = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const delegatorId = searchParams.get("dt");
    const delegateEmail = searchParams.get("de");
    const [user, setUser] = useState({
        firstName: "",
        lastName: "",
        email: "",
        verifyEmail: "",
        userName: "",
        password: "",
        verifyPassword: "",
        tin: "",
        policyNumber: "",
        middleName: "",
        state: "",
        zipCode: "",
        suffix: "",
        tinType: "",
        saidCode: "",
        role: "",
        delegationError: "",
        firm: ""
    });
    const [termsAndConditionsOpen, setTermsAndConditionsOpen] = useState(false);
    const [errors, setErrors] = useState({
        firstName: "",
        lastName: "",
        email: "",
        verifyEmail: "",
        userName: "",
        password: "",
        verifyPassword: "",
        tin: "",
        policyNumber: "",
        middleName: "",
        state: "",
        zipCode: "",
        suffix: "",
        tinType: "",
        saidCode: "",
        role: "",
        delegatorId: "",
        firm: ""
    });
    const [toastMessage, setToastMessage] = useState("");
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const [submitting, setsubmitting] = useState(false);

    const setTermsAndConditions = (e) => {
        setTermsAndConditionsOpen(true);
    };

    const closeTermsAndConditions = (value) => {
        setTermsAndConditionsOpen(value);
    };

    useEffect(() => {
        analytics();
    }, []);

    useEffect(() => {
        const role = DELEGATE;
        const requiredFields = REQUIRED_FIELDS[role];
        for (const element of requiredFields) {
            const fieldName = element;
            if (!user[fieldName]) {
                setSubmitDisabled(true);
                return;
            }
        }

        const errorFields = Object.keys(errors);
        for (const element of errorFields) {
            const fieldName = element;
            if (errors[fieldName] !== "") {
                setSubmitDisabled(true);
                return;
            }
        }
    }, [user, errors]);

    const handleCancel = (e) => {
        window.location.href = "/login/account/fp-landing-page.html";
    };

    useEffect(() => {
        document.title =
            "Financial Professional- Delegates Registration | Pacific Life";
        validateDelegation();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const payload = { [name]: value };
        setUser((prev) => ({ ...prev, ...payload }));
    };

    const handleBlur = async (e) => {
        const { name, value } = e.target;
        let errorMessage = "";

        if (name === "policyNumber") {
            if (value.length === 0 && !user.saidCode) {
                errorMessage = "Policy Number or Agent Code must be entered";
            } else if (/[^a-zA-Z0-9*]/g.test(value)) {
                errorMessage =
                    "Policy Number must not contain spaces or numbers or special characters";
            } else {
                errorMessage = "";
                errors.saidCode = "";
            }
        }
        if (name === "saidCode") {
            if (value.length === 0 && !user.policyNumber) {
                errorMessage = "Policy Number or Agent Code must be entered";
            } else if (/[^a-zA-Z0-9*]/g.test(value)) {
                errorMessage =
                    "Policy Number must not contain spaces or numbers or special characters";
            } else {
                errorMessage = "";
                errors.policyNumber = "";
            }
        }
        if (name === "dob") {
            if (value.length === 0) {
                errorMessage = "Insured's Date of Birth must be entered";
            } else {
                errorMessage = "";
            }
        }
        if (name === "trustName") {
            if (user.tinType === "T") {
                if (value) {
                    if (/[^[a-zA-Z0-9\s()&,''-]/.test(value)) {
                        errorMessage =
                            "Trust/Organization entered is not valid";
                    }
                }
            }
        }
        if (name === "tin") {
            const valid = ssnValidation(value);

            if (value.length === 0) {
                errorMessage = "Tax ID is required.";
            } else {
                if (/\d{3}00\d{4}$/.test(value)) {
                    errorMessage = "Please enter a valid Tax ID.";
                } else if (/00\d{7}$/.test(value)) {
                    errorMessage = "Please enter a valid Tax ID.";
                } else if (/000\d{6}$/.test(value)) {
                    errorMessage = "Please enter a valid Tax ID.";
                } else if (/\d{5}0000$/.test(value)) {
                    errorMessage = "Please enter a valid Tax ID.";
                } else if (/^123456789$/.test(value)) {
                    errorMessage = "Please enter a valid Tax ID.";
                } else if (/^777777777$/.test(value)) {
                    errorMessage = "Please enter a valid Tax ID.";
                } else if (/^888888888$/.test(value)) {
                    errorMessage = "Please enter a valid Tax ID.";
                } else if (/^999999999$/.test(value)) {
                    errorMessage = "Please enter a valid Tax ID.";
                } else {
                    errorMessage = valid ? "" : "Please enter a valid Tax ID.";
                }
            }
        }

        if (name === "isCheckedFindMyPolicy") {
            errorMessage = e.target.checked
                ? ""
                : "Agree to the terms and conditions";
        }

        if (name === "tinType") {
            errorMessage = e.target.value !== "" ? "" : "Select SSN or TIN";
        }

        if (name === "firstName") {
            if (value.length === 0) {
                errorMessage = "First name is required.";
            } else if (/[^a-zA-Z-. ]/.test(value)) {
                errorMessage =
                    "Names can only include letters and standard punctuation.";
            } else {
                errorMessage = "";
            }
        }

        if (name === "middleName") {
            if (/[^a-zA-Z ]/.test(value)) {
                errorMessage = "Please use letters only for this field.";
            } else {
                errorMessage = "";
            }
        }

        if (name === "suffix") {
            if (/[^a-zA-Z ]/.test(value)) {
                errorMessage = "Please use letters only for this field.";
            } else {
                errorMessage = "";
            }
        }

        if (name === "lastName") {
            if (value.length === 0) {
                errorMessage = "Last name is required.";
            } else if (/[^a-zA-Z-. ]/.test(value)) {
                errorMessage =
                    "Names can only include letters and standard punctuation.";
            } else {
                errorMessage = "";
            }
        }

        if (name === "email") {
            const emailValid = emailValidation(value);
            if (value.length === 0) {
                errorMessage = "Please enter your email address.";
            } else {
                errorMessage = emailValid
                    ? ""
                    : "Please enter a valid email address (e.g., name@example.com).";
            }
        }

        if (name === "verifyEmail") {
            const emailConfirmValid = emailValidation(value);

            if (value.length === 0) {
                errorMessage = " Please confirm your email address.";
            } else {
                errorMessage = emailConfirmValid
                    ? ""
                    : "Email addresses do not match. Please re-enter.";
            }
            if (!errorMessage) {
                errorMessage = emailVerifyMatch(user.email, value)
                    ? ""
                    : "Email addresses do not match. Please re-enter.";
            }
        }

        if (name === "phoneNumber") {
            errorMessage =
                value.length < 14 ? "Enter a valid 10 digit phone number" : "";
        }
        if (name === "verifyPhoneNumber") {
            errorMessage =
                value.length < 14 ? "Enter a valid 10 digit phone number" : "";
            errorMessage =
                user.phoneNumber !== value
                    ? "Phone number do not match"
                    : errorMessage;
        }
        if (name === "password") {
            errorMessage =
                value.length < 6
                    ? "Enter a valid password above 6 characters"
                    : "";
        }
        if (name === "confirmPassword") {
            errorMessage =
                user.password !== value
                    ? "Password do not match"
                    : errorMessage;
        }
        if (name === "zipCode") {
            if (value.length < 5) {
                errorMessage =
                    "Enter the five digit ZIP code of your primary residence";
            }
        }

        if (name === "state") {
            if (user.state) {
                errorMessage = user.state !== "" ? "" : "Select State";
            } else {
                errorMessage = "Select State";
            }
        }

        if (name === "role") {
            if (user.role) {
                errorMessage =
                    user.role !== "" ? "" : "Please select your role.";
            } else {
                errorMessage = "Please select your role.";
            }
        }

        if (name === "id") {
            const validUserName = userNameValidation(value);
            const emailValid = emailValidation(value);
            const tooShortOrLongUserName =
                value.length < 5 || value.length > 20;
            if (emailValid && !errorMessage) {
                errorMessage = "Do not enter an email in the Username field.";
            }
            if (value) {
                if (value.length === 0) {
                    errorMessage = "Please enter a username.";
                }
            } else {
                errorMessage = "Please enter a username.";
            }
            if (value.indexOf(" ") > -1 && !errorMessage) {
                errorMessage = "Username name should not contain space.";
            }
            if (/[^a-zA-Z0-9-_. ]/.test(value) && !errorMessage) {
                errorMessage =
                    "Username can only include letters, numbers, and underscores.";
            }
            if (validUserName) {
                errorMessage = "";
            } else if (tooShortOrLongUserName && !errorMessage) {
                errorMessage =
                    "Username must be at least 5 characters and no more than 20 characters.";
            }
        }
        if (errorMessage != "") {
            setSubmitDisabled(true);
        } else {
            setSubmitDisabled(false);
        }
        setErrors((prev) => ({ ...prev, [name]: errorMessage }));
    };

    const validateDelegation = async (e) => {
        let errMsg = "";
        const payload = {
            delegatorUserId: delegatorId,
            delegateeEmail: delegateEmail
        };
        try {
            const res = await axios({
                method: "POST",
                url: "/life/enroll/api/userenroll/fp/delegate/validate",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload)
            }).catch(function (err) {
                if (err.response) {
                    errMsg = err.response?.data?.error?.message;
                    console.log(
                        err.response?.data?.error?.message ||
                            err.response?.data ||
                            "Something went wrong.  Please try again later."
                    );
                    setUser({
                        delegationError:
                            errMsg ||
                            "Something went wrong. Please try again later."
                    });
                } else if (err.request) {
                    const pu = {
                        delegationError:
                            errMsg ||
                            "Something went wrong. Please try again later."
                    };
                    setUser((prev) => ({ ...prev, ...pu }));
                    console.log(err.request);
                } else {
                    const pu = {
                        delegationError:
                            errMsg ||
                            "Something went wrong. Please try again later."
                    };
                    setUser((prev) => ({ ...prev, ...pu }));
                    console.log("Error", err.message);
                }
            });
            if (res.status === 200) {
                if (res.data.data.delegateeEmail) {
                    const pu = {
                        email: res.data.data.delegateeEmail,
                        delegatorId: res.data.data.delegatorId
                    };
                    setUser((prev) => ({ ...prev, ...pu }));
                }
            }
        } catch (error) {
            setUser({
                delegationError:
                    errMsg || "Something went wrong. Please try again later."
            });
        }
        setsubmitting(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let errMsg = "";
        //const test = JSON.stringify(payload);
        setsubmitting(true);

        const payload = await formatPayloadProfile();
        try {
            const res = await axios({
                method: "POST",
                url: "/life/enroll/api/userenroll/fp/delegate/enroll/",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(payload)
            }).catch(function (err) {
                if (err.response) {
                    errMsg = err.response?.data?.error?.message;
                    console.log(
                        err.response?.data?.error?.message ||
                            err.response?.data ||
                            "Something went wrong. Please try again later."
                    );
                    setToastMessage(
                        errMsg ||
                            "Something went wrong. Please try again later."
                    );
                } else if (err.request) {
                    console.log(err.request);
                } else {
                    console.log("Error", err.message);
                }
            });
            if (res.status === 200) {
                window.location.href = "/login/account/reg-successful.html";
            }
        } catch (error) {
            setToastMessage(
                errMsg ||
                    error.response?.data?.errorMessage ||
                    "Something went wrong. Please try again later."
            );
        }
        setsubmitting(false);
    };

    const formatPayloadProfile = async () => {
        return {
            id: "",
            firstName: user.firstName,
            delegatorId: user.delegatorId,
            lastName: user.lastName,
            ssnTin: user.tin,
            createdBy: user.id,
            email: user.email,
            userId: user.id,
            zipCode: user.zipCode,
            roles: ["staff"],
            middleName: user.middleName,
            password: user.password,
            policyNumber: user.policyNumber,
            ipAddress: await getIPAddress(),
            suffix: user.suffix,
            saidCode: user.saidCode,
            state: user.state,
            companyName: user.firm,
            delegatorUserId: delegatorId,
            delegateeEmail: delegateEmail
        };
    };

    const closeToast = () => {
        setToastMessage("");
    };

    return (
        <>
            {toastMessage !== "" && (
                <Toast onClose={closeToast} className="toast-cont">
                    <Toast.Header>
                        <strong className="me-auto">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: toastMessage
                                }}
                            ></div>
                        </strong>
                    </Toast.Header>
                </Toast>
            )}
            <Header />
            {user.delegationError && (
                <div className="mainMyAccount">{user.delegationError}</div>
            )}
            {!user.delegationError && !user.email && (
                <div className="mainMyAccount">Loading..</div>
            )}
            {user.email && (
                <div className="mainMyAccount">
                    <h1 className="heading">
                        Create a Financial Professional Account
                    </h1>
                    <div style={{ fontWeight: "bold" }}>
                        (Non-contracted / non-appointed invitee or delegate)
                    </div>
                    <br />
                    <div>
                        {" "}
                        The Life Insurance Websites and online tools are for
                        Pacific Life Appointed Life Insurance Producers
                        including Principals, Consultants and their delegates or
                        invited users, including back office staff and office
                        admins. A valid profile with an active Username,
                        Password and MFA are required for access.
                        <br />
                        <br />
                        Contracted and appointed reps with Pacific Life may{" "}
                        <a href="/login/account/fp-landing-page.html">
                            register or login here
                        </a>
                    </div>
                    <Form
                        onKeyDown={(e) => {
                            if (e.key === "Enter") e.preventDefault();
                        }}
                    >
                        <Row>
                            <Col sm={12}>
                                <label className="sub-title">
                                    Personal Information
                                </label>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={3}>
                                <Form.Label>First Name</Form.Label>
                                <Form.Control
                                    name="firstName"
                                    autoComplete="off"
                                    maxLength={25}
                                    value={user.firstName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <span className="validation-error-message">
                                    {errors.firstName}
                                </span>
                            </Col>
                            <Col md={3}>
                                <Form.Label>
                                    Middle Initial (Optional)
                                </Form.Label>
                                <Form.Control
                                    name="middleName"
                                    autoComplete="off"
                                    maxLength={25}
                                    value={user.middleName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <span className="validation-error-message">
                                    {errors.middleName}
                                </span>
                            </Col>
                            <Col md={3}>
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control
                                    name="lastName"
                                    autoComplete="off"
                                    maxLength={35}
                                    value={user.lastName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <span className="validation-error-message">
                                    {errors.lastName}
                                </span>
                            </Col>
                            <Col md={3}>
                                <Form.Label>Suffix (Optional)</Form.Label>
                                <Form.Control
                                    name="suffix"
                                    autoComplete="off"
                                    maxLength={5}
                                    value={user.suffix}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <span className="validation-error-message">
                                    {errors.suffix}
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <ReactTooltip />
                                <Form.Label className="emailClass">
                                    Email
                                    <QuestionCircle
                                        tabIndex="-1"
                                        className="iconClass"
                                        data-tip="Website related communications and password reset links will be sent to this email."
                                    />
                                </Form.Label>
                                <Form.Label className="emailClass">
                                    {user.email}
                                </Form.Label>

                                <span className="validation-error-message">
                                    {errors.email}
                                </span>
                            </Col>
                            <Col md={6}>
                                <Form.Label>Firm/Agency (Optional)</Form.Label>
                                <Form.Control
                                    name="firm"
                                    autoComplete="off"
                                    maxLength={50}
                                    value={user.firm}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <span className="validation-error-message">
                                    {errors.firm}
                                </span>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={12}>
                                <label className="sub-title">
                                    Login Information
                                </label>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <ReactTooltip />
                                <Form.Label className="createUsername">
                                    User Name
                                    <QuestionCircle
                                        tabIndex="-1"
                                        className="iconClass"
                                        data-tip="Your Username and Password will be used to login to the Life Insurance Financial Professional Portals on the Pacific Life domain."
                                    />
                                </Form.Label>
                                <Form.Control
                                    name="id"
                                    autoComplete="off"
                                    maxLength={20}
                                    value={user.id}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                <span className="validation-error-message">
                                    {errors.id}
                                </span>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                &nbsp;&nbsp;By clicking on "Register", you agree
                                to abide by these
                                <a href="#" onClick={setTermsAndConditions}>
                                    {" "}
                                    terms and conditions.
                                </a>{" "}
                                <br />
                                <TermsAndConditions
                                    TermsAndConditionsOpen={
                                        termsAndConditionsOpen
                                    }
                                    CloseTermsAndConditions={
                                        closeTermsAndConditions
                                    }
                                ></TermsAndConditions>
                            </Col>
                        </Row>

                        <div className="buttons-myaccount">
                            <Button
                                variant="secondary"
                                type="button"
                                onClick={handleCancel}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="primary"
                                type="submit"
                                onClick={handleSubmit}
                                data-track="analytics"
                                disabled={submitDisabled || submitting}
                            >
                                {submitting ? "Registering" : "Register"}
                            </Button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                        </div>

                        <div>
                            <a href="/login/account/fp-landing-page.html">
                                Already have an account?
                            </a>
                        </div>
                    </Form>

                    <DisclaimerPolicyOwner />
                </div>
            )}
            <Footer />
        </>
    );
};

export default DelegateEnroll;
